import React from 'react'
import { Form } from 'semantic-ui-react'
import { CheckClimaEl } from '../../../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import InfoPopup from '~/components/InfoPopup'
import TableLandUse from './TableLandUse'
import { ClimateCheckSelectType } from '~/api/services/climaCheck'

interface Props {
  landTypes: ClimateCheckSelectType[]
}

const FifthteenStep: React.FC<Props> = ({ landTypes }) => {
  const { control } = useFormContext()

  const fieldNames = [
    'silageMaizeArea',
    'organicSoilSilageMaizeArea',
    'permanentGrasslandArea',
    'organicSoilPermanentGrasslandArea',
    'arableGrassArea',
    'organicSoilArableGrassArea'
  ]

  const [
    watchMaiseCultivation,
    watchMaiseOrganicSoile,
    watchGrassLandAre,
    watchGrassOrganicSoile,
    watchGrassArea,
    watchGrassOrganicSoil
  ] = useWatch({ control, name: fieldNames })

  function renderLandUse() {
    return <div style={{ marginBottom: '2em' }}>
      <div style={{ width: 'fit-content' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 3 }}>
          <div>{'Landnutzung'}</div>
          <InfoPopup
            content={'Bitte geben sie hier ausschließlich die Flächen an, auf denen Sie Futter für ihre Milchkühe und ihre weibliche Nachzucht produziert haben.'}
            styleIcon={{ fontSize: '1.2em' }}
            position={'top center'}
          />
        </div>
        <CheckClimaEl.StyledDivider />
      </div>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'silageMaizeArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Silomais'}</label>
            <InfoPopup
              position={'top center'}
              styleIcon={{ fontSize: '1.2em' }}
              content={'Wie groß war die Anbaufläche für Silomais, der ausschließlich in der Milchproduktion verfüttert wurde?'}
            />
          </div>}
          rules={{
            required: Boolean(watchMaiseOrganicSoile),
            min: watchMaiseOrganicSoile ?? 0
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilSilageMaizeArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Silomais auf org. Boden'}</label>
            <InfoPopup
              position={'top center'}
              style={{ minWidth: 500 }}
              styleIcon={{ fontSize: '1.2em' }}
              content={<div dangerouslySetInnerHTML={{ __html: `<div>Von diesen Silomaisflächen, wie viel ha waren organischer Boden? Bspw. Moorige/anmoorige Flächen? 1 und 2 oder 1 und 3 müssen erfüllt sein:</div> 
                <div>1. Dicke des organischen Horizonts ≥ 10 cm. Ein Horizont von weniger als 20 cm muss 12 % oder mehr organischen Kohlenstoff enthalten, wenn er bis zu einer Tiefe von 20 cm vermischt wird.</div>
                <div>2. Böden, die höchstens einige Tage mit Wasser gesättigt sind, müssen > 20 % organischen Kohlenstoff (ca. 35 % org. Substanz) enthalten.</div>
                <div>3. Böden sind phasenweise mit Wasser gesättigt und weisen auf:</div>
                  <div style="margin-left: 5px;">a) Boden ohne Ton: min. 12 % organischer Kohlenstoff (20 % org. Substanz)</div>
                  <div style="margin-left: 5px;">b) Boden mit min. 60 % Tonanteil: min. 18 % org. Kohlenstoff (30 % org. Substanz), wenn der Boden mindestens 60 % Ton enthält</div>
                  <div style="margin-left: 5px;">c) dazwischenliegender Gehalt org. Kohlenstoff bei dazwischenliegendem Gehalt von Ton.</div>`
              }}/>}
            />
          </div>}
          rules={{
            required: Boolean(watchMaiseCultivation),
            max: watchMaiseCultivation ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'permanentGrasslandArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Dauergrünland'}</label>
            <InfoPopup
              position={'top center'}
              styleIcon={{ fontSize: '1.2em' }}
              content={'Wie groß war die Dauergrünlandfläche, deren Erträge ausschließlich in der Milchproduktion (inkl. Färsenaufzucht) verfüttert wurden? Für Grassilage, Weide, Heulage, Heu, etc.'}
            />
          </div>}
          rules={{
            required: Boolean(watchGrassOrganicSoile),
            min: watchGrassOrganicSoile ?? 0
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilPermanentGrasslandArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Dauergrünland auf org. Boden'}</label>
            <InfoPopup
              position={'top center'}
              style={{ minWidth: 500 }}
              styleIcon={{ fontSize: '1.2em' }}
              content={<div dangerouslySetInnerHTML={{ __html: `<div>Von diesen Dauergrünlandflächen, wie viel ha waren organischer Boden? Bspw. Moorige/anmoorige Flächen. 1 und 2 oder 1 und 3 müssen erfüllt sein:</div> 
                <div>1. Dicke des organischen Horizonts ≥ 10 cm. Ein Horizont von weniger als 20 cm muss 12 % oder mehr organischen Kohlenstoff enthalten, wenn er bis zu einer Tiefe von 20 cm vermischt wird.</div>
                <div>2. Böden, die höchstens einige Tage mit Wasser gesättigt sind, müssen > 20 % organischen Kohlenstoff (ca. 35 % org. Substanz) enthalten.</div>
                <div>3. Böden sind phasenweise mit Wasser gesättigt und weisen auf:</div>
                  <div style="margin-left: 5px;">a) Boden ohne Ton: min. 12 % organischer Kohlenstoff (20 % org. Substanz).</div>
                  <div style="margin-left: 5px;">b) Boden mit min. 60 % Tonanteil: min. 18 % org. Kohlenstoff (30 % org. Substanz), wenn der Boden mindestens 60 % Ton enthält.</div>
                  <div style="margin-left: 5px;">c) dazwischenliegender Gehalt org. Kohlenstoff bei dazwischenliegendem Gehalt von Ton.</div>`
              }}/>}
            />
          </div>}
          rules={{
            required: Boolean(watchGrassLandAre),
            max: watchGrassLandAre ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'arableGrassArea'}
          suffix={' ha'}
          rules={{
            required: Boolean(watchGrassOrganicSoil),
            min: watchGrassOrganicSoil ?? 0
          }}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Anbaufläche Ackergras'}</label>
            <InfoPopup
              position={'top center'}
              styleIcon={{ fontSize: '1.2em' }}
              content={'Wie groß war die Anbaufläche für Ackergras/-mischungen, die ausschließlich in der Milchproduktion (inkl. Färsenaufzucht) verfüttert wurden? Für Grassilage, Weide, Heulage, Heu, etc.'}
            />
          </div>}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
        <FormFields.Input
          control={control}
          name={'organicSoilArableGrassArea'}
          suffix={' ha'}
          withoutAsterisk
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: '0.5em' }}>
            <label>{'Ackergras auf org. Boden'}</label>
            <InfoPopup
              position={'top center'}
              style={{ minWidth: 500 }}
              styleIcon={{ fontSize: '1.2em' }}
              content={<div dangerouslySetInnerHTML={{ __html: `<div>Von diesen Ackergrasflächen, wie viel ha waren organischer Boden? Bspw. Moorige/anmoorige Flächen? 1 und 2 oder 1 und 3 müssen erfüllt sein:</div> 
                <div>1. Dicke des organischen Horizonts ≥ 10 cm. Ein Horizont von weniger als 20 cm muss 12 % oder mehr organischen Kohlenstoff enthalten, wenn er bis zu einer Tiefe von 20 cm vermischt wird.</div>
                <div>2. Böden, die höchstens einige Tage mit Wasser gesättigt sind, müssen > 20 % organischen Kohlenstoff (ca. 35 % org. Substanz) enthalten.</div>
                <div>3. Böden sind phasenweise mit Wasser gesättigt und weisen auf:</div>
                  <div style="margin-left: 5px;">a) Boden ohne Ton: min. 12 % organischer Kohlenstoff (20 % org. Substanz).</div>
                  <div style="margin-left: 5px;">b) Boden mit min. 60 % Tonanteil: min. 18 % org. Kohlenstoff (30 % org. Substanz), wenn der Boden mindestens 60 % Ton enthält.</div>
                  <div style="margin-left: 5px;">c) dazwischenliegender Gehalt org. Kohlenstoff bei dazwischenliegendem Gehalt von Ton.</div>`
              }}/>}
            />
          </div>}
          rules={{
            required: Boolean(watchGrassArea),
            max: watchGrassArea ?? null
          }}
          typeInput='controled'
          noErrorMessage
          placeholder={'in ha'}
        />
      </Form.Group>
    </div>
  }

  function renderLandUseChange() {
    return <div>
      <div style={{ width: 'fit-content' }}>
        <div style={{ display: 'flex', gap: 5 }}>
          {'Landnutzungsänderung'}
          <InfoPopup
            position={'top center'}
            styleIcon={{ fontSize: '1.2em' }}
            content={'Hat sich in den letzten 20 Jahren der Status der für die Milchproduktion genutzten Flächen verändert? Bitte geben Sie nur prüfbare Werte ein, sonst keine Eingabe.'}
          />
        </div>
        <CheckClimaEl.StyledDivider />
      </div>
      <TableLandUse
        landTypes={landTypes}
      />
    </div>
  }

  return <div>
    {renderLandUse()}
    {renderLandUseChange()}
  </div>
}
export default FifthteenStep